<template>
  <div
    class="box-border flex items-center rounded-md border border-solid border-neutral-200 bg-neutral-50 dark:border-neutral-400 dark:bg-neutral-700 dark:text-neutral-300"
    :class="compact ? 'gap-4 p-2' : 'gap-6 px-6 py-2'"
  >
    <div class="text-center">
      <img :src="ImgGamePoints" alt="" class="h-8 w-8" />
      <div class="whitespace-nowrap font-semibold">{{ data?.score || '' }} pts</div>
    </div>

    <div class="grow">
      <div v-if="data?.content"><span class="font-semibold">{{ t('labels.content') }}:</span> {{ data?.content || '' }}</div>
      <div><span class="font-semibold">{{ t('labels.objective') }}:</span> {{ data?.rule || '' }}</div>
      <div v-if="data?.date" class="font-semibold">{{ `${t('gamification.conquered')} ${formatter.date(data?.date)}` }}</div>
    </div>
    <button
      v-if="false && !compact && isSupported"
      class="cursor-pointer border-0 bg-transparent text-neutral-400 hover:text-neutral-600"
      @click="startShare()"
    >
      <UiIcon icon="share" size="24px" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useShare } from '@vueuse/core'
import { formatter } from '@/common/util'

import UiIcon from '@/components/ui/icon.vue'
// import ImgTrophy from '@/assets/game/trophy.png'
import ImgGamePoints from '@/assets/game/icon-points.svg'

const { share, isSupported } = useShare()

const { t } = useI18n()

const props = defineProps<{
  data: {
    date: Date
    environment: string
    rule: string
    content: string
    score: number
  }
  compact?: boolean
}>()

function startShare() {
  share({
    title: props.data?.rule || t('labels.conquest'),
    text: t('gamification.achievementReceived'),
    url: location.href
  })
}
</script>
